export enum FAMILY_PORTAL_TYPES {
    // eslint-disable-next-line no-unused-vars
  FAMILY = 'FAMILY',
}
